// has number
const hasNumber = (number) => new RegExp(/[0-9]/).test(number);
 
// has mix of small and capitals
const hasMixed1 = (number) => new RegExp(/[a-z]/).test(number);

const hasMixed2 = (number) => new RegExp(/[A-Z]/).test(number);
 
// has special chars
const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);
 
// set color based on password strength
export const strengthColor = (count) => {
    if (count < 2) return { lever: count, label: '弱', color: '#ff0000' };
    if (count < 3) return { lever: count, label: '较弱', color: '#ffda00' };
    if (count < 4) return { lever: count, label: '中', color: '#fff200' };
    if (count < 5) return { lever: count, label: '较强', color: '#67ff00' };
    if (count < 6) return { lever: count, label: '强', color: '#21ff00' };
    return { lever: count,label: '弱', color: '#ff0000' };
};
// password strength indicator
export const strengthIndicator = (number) => {
    let strengths = 0;
    // if (number.length > 8) strengths += 1;
    if (hasNumber(number)) strengths += 1;
    if (hasSpecial(number)) strengths += 1;
    if (hasMixed1(number)) strengths += 1;
    if (hasMixed2(number)) strengths += 1;
	
    return strengthColor(strengths);
};


//////////////////
// WEBPACK FOOTER
// ./store/password-strength.js
// module id = null
// module chunks = 